// extracted by mini-css-extract-plugin
export default {"switch":"toggle-field_switch__P8noO","checked":"toggle-field_checked__LbzYn","disabled":"toggle-field_disabled__URKAM","thumb":"toggle-field_thumb__T92EM"};